module.exports = __webpack_public_path__ + "static/media/feedlogic-2.a8efe0bd.jpg";